import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";
import { PageHeading } from "../MediaCentre/Media.hook";

interface DocumentDetailsResponse {
  id: number;
  title: string;
  field_awards_title_ms: string;
  field_awards_zh: string;
  field_awards_description_en: string;
  field_awards_description_ms: string;
  field_awards_description_zh: string;
  sequence: number;
  field_awards_page_name_en: string;
  field_awards_page_ms: string;
  field_awards_page_zh: string;
  image: string;
  field_awards_image: string;
  year: number;
  published: boolean;
  created_at: string;
  updated_at: string;
  field_awards_sequence: number;
  field_awards_year: number;
  field_awards_created_at: string;
  field_awards_updated_at: string;
}
interface NewsNextPage {
  id: number;
  title: string;
  field_content_english: {
    data: {
      nextPage: {
        name: string;
        link: string;
      };
    };
  };
  field_content_malay: {
    data: {
      nextPage: {
        name: string;
        link: string;
      };
    };
  };
  field_content_mandarin: {
    data: {
      nextPage: {
        name: string;
        link: string;
      };
    };
  };
  field_page: string;
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

// edit api call
const fetchAwardsDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await corporateCMSApi.get(`/api/get-awards-id/${id}`);
  return response.data[0];
};

const useAwardsDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["awardsDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchAwardsDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useAwardsPageHeading = (
  options?: UseQueryOptions<PageHeading[], DefaultError, PageHeading[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<PageHeading[], DefaultError> => {
  return useQuery<PageHeading[], DefaultError, PageHeading[], QueryKey>(
    {
      queryKey: ["awardsPageHeading"],
      enabled: false,
      queryFn: async (): Promise<PageHeading[]> => {
        const response = await corporateCMSApi.get<PageHeading[]>(
          `/api/page-heading/all-fields?pageName=about-us/awards`
        );
        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};
const useAwardsNewsNextPage = (
  options?: UseQueryOptions<NewsNextPage[], DefaultError, NewsNextPage[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<NewsNextPage[], DefaultError> => {
  return useQuery<NewsNextPage[], DefaultError, NewsNextPage[], QueryKey>(
    {
      queryKey: ["awardsNewsNextPage"],
      enabled: false,
      queryFn: async (): Promise<NewsNextPage[]> => {
        const response = await corporateCMSApi.get<NewsNextPage[]>(
          `/api/page-content/all-fields?pageName=about-us/awards`
        );
        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useAwardsDocumentDetails, useAwardsNewsNextPage, useAwardsPageHeading };
